export const ELEVATION = {
    DRAGGING: 12,
    IN_PLACE: 0
};

export const ROOT_INDEX = 0;
